import React, { useState } from 'react';
import DashboardLayout from '../Layout/DashboardLayout';
import './Admin.css';

const AdminSettings = () => {
    const [activeSettings, setActiveSettings] = useState({
        metaAppId: '123456789012345',
        metaAppSecret: '••••••••••••••••••••••••',
        whatsappBusinessId: '543210987654321',
        systemEmail: 'admin@messagepe.com',
        razorpayKeyId: 'rzp_test_abc123',
        googleClientId: '12345678-abc.apps.googleusercontent.com'
    });

    return (
        <DashboardLayout isAdmin={true}>
            <div className="admin-page">
                <header className="admin-header">
                    <h1>System Settings</h1>
                    <button className="btn btn--primary">Save All Settings</button>
                </header>

                <div className="admin-section">
                    <h2>Meta API Configuration</h2>
                    <div className="admin-form-grid">
                        <div className="form-group">
                            <label className="form-label">Meta App ID</label>
                            <input type="text" className="form-control" value={activeSettings.metaAppId} readOnly />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Meta App Secret</label>
                            <input type="password" className="form-control" value={activeSettings.metaAppSecret} readOnly />
                        </div>
                        <div className="form-group">
                            <label className="form-label">WABA Business ID (Default)</label>
                            <input type="text" className="form-control" value={activeSettings.whatsappBusinessId} readOnly />
                        </div>
                    </div>
                </div>

                <div className="admin-section">
                    <h2>Payment & Auth Gateway</h2>
                    <div className="admin-form-grid">
                        <div className="form-group">
                            <label className="form-label">Razorpay Key ID</label>
                            <input type="text" className="form-control" value={activeSettings.razorpayKeyId} readOnly />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Google Client ID</label>
                            <input type="text" className="form-control" value={activeSettings.googleClientId} readOnly />
                        </div>
                    </div>
                </div>

                <div className="admin-section">
                    <h2>Email Notifications</h2>
                    <div className="admin-form-grid">
                        <div className="form-group">
                            <label className="form-label">System Notification Email</label>
                            <input type="email" className="form-control" value={activeSettings.systemEmail} readOnly />
                        </div>
                        <div className="form-group">
                            <label className="form-label">SMTP Server</label>
                            <input type="text" className="form-control" placeholder="smtp.gmail.com" />
                        </div>
                        <div className="form-group">
                            <label className="form-label">SMTP Port</label>
                            <input type="number" className="form-control" placeholder="587" />
                        </div>
                    </div>
                </div>

                <div className="admin-section">
                    <h2>Danger Zone</h2>
                    <div className="d-flex gap-4">
                        <button className="btn btn--outline text-danger border-danger">Clear System Cache</button>
                        <button className="btn btn--outline text-danger border-danger">Restart Background Tasks</button>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default AdminSettings;
